import React, { useState, useRef } from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import Text from '../textStyleDefault/texto'
import ServiciosDropdown from './serviciosDropdown'
import useClickOutside from './useClickOutside'

interface NavbarLinksProps {
  color: string
  variant?: 'header' | 'footer' | 'menu'
  onClick?: () => void
}

const NavbarLinks = (props: NavbarLinksProps): JSX.Element => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const dropdownRef = useRef<HTMLLIElement>(null)

  // Usamos el hook useClickOutside para cerrar el menú cuando se hace click fuera de él
  useClickOutside(dropdownRef, () => { setOpen(false) })

  return (
    <ul className={clsx('flex', {
      'flex-row text-white space-x-[32px] justify-center w-48 mx-auto': props.variant === 'header',
      'items-start flex-col space-y-[16px] right-[10%]': props.variant === 'footer',
      'text-white items-center flex-col w-screen': props.variant === 'menu'
    }, props.variant === 'menu' ? (open ? 'space-y-[12px]' : 'space-y-[32px]') : '')}>
      <div className={clsx(
        props.variant === 'menu' && 'w-[94.44%] flex justify-center',
        'md:border-b-[1px]',
        open ? 'md:border-white' : 'md:border-transparent'
      )}>
        <li
          ref={dropdownRef} // Referenciamos el li que contiene el dropdown
          style={{ color: props.color }}
          className={clsx('pt-[1px]', props.variant === 'header' && 'flex justify-center text-[20px]', 'relative')}
        >
          <div
            onClick={() => { setOpen(!open) }}
            className={clsx('flex items-center cursor-pointer', props.variant === 'menu' && 'justify-center')}
          >
            <Text as='h6' className={clsx('block', {
              'text-[16px] md:text-[20px]': props.variant === 'footer',
              'ml-[14px] text-[20px]': props.variant === 'menu'
            })}>
              {t('servicios')}
            </Text>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24" height="24"
              viewBox="0 0 24 24"
              className={clsx('mt-[6px] transition-transform duration-100', open && 'rotate-180')}
              fill={props.color}
            >
              <path d="M7.41 8.295L12 12.875L16.59 8.295L18 9.705L12 15.705L6 9.705L7.41 8.295Z" />
            </svg>
          </div>
          {open && (
            <ServiciosDropdown
              color={props.color}
              variant={props.variant}
              onClose={() => {
                setOpen(false)
                props.onClick?.()
              }}
            />
          )}
        </li>
      </div>
      <li className={clsx('block', props.variant === 'footer' && 'text-[16px] md:text-[20px]', props.variant === 'header' && 'text-[20px]')}>
        <NavLink to='casos-de-exito/' className='flex' onClick={props.onClick}>
          {t('proyectos')}
        </NavLink>
      </li>
      <li className={clsx('block', props.variant === 'footer' && 'text-[16px] md:text-[20px]', props.variant === 'header' && 'text-[20px]')}>
        <NavLink to='la-empresa/' className='flex' onClick={props.onClick}>
          {t('nosotros')}
        </NavLink>
      </li>
    </ul>
  )
}

export default NavbarLinks
